import actions from '~/store/modules/shared/classifieds/edit/actions'
import mutations from '~/store/modules/shared/classifieds/edit/mutations'
import getters from '~/store/modules/shared/classifieds/edit/getters'
import state from '~/store/modules/shared/classifieds/edit/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  mutations,
  getters,
  state
})
